import {
  IonMenu,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonList,
  IonMenuToggle,
  IonItem,
  IonLabel,
  IonIcon,
  IonRouterLink,
} from "@ionic/react";
import { Auth } from "aws-amplify";
import React, { useContext, useEffect, useState } from "react";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import * as Helpers from "../../services/Helpers";
import {
  addCircle,
  home,
  people,
  person,
  personAdd,
  call,
  exit,
  medkit,
  fileTrayStackedSharp,
  fileTrayFullSharp,
  folder,
  pulse,
  analytics,
  notifications,
  options,
  business,
  bed,
  menuOutline,
  chevronBackOutline
} from "ionicons/icons";
import { Chart, registerables } from "chart.js";
import { useHistory } from "react-router-dom";
import "./Menu.css"; // Custom CSS file
import { useTranslations } from "../../hooks/useTranslations";

export const Menu = ({ onCollapse }: { onCollapse: (collapsed: boolean) => void }) => {
  Chart.register(...registerables);
  const { userState, setUserState } = useContext(ApplicationContext);
  const { providerState } = useContext(ProviderContext);
  const [userAttributes, setUserAttributes] = React.useState<any | undefined>(
    {}
  );

  const [isCollapsed, setIsCollapsed] = useState(false);

  const labels = useTranslations()

  const logout = () => {
    setUserState({ authenticatedUser: undefined });
    Auth.signOut();
  };

  useEffect(() => {
    let user = userState?.authenticatedUser;
    let attr = Helpers.getUserAttributes(
      user?.signInUserSession["idToken"].jwtToken
    );
    setUserAttributes(attr);
  }, [userState]);

  const toggleMenu = () => {
    setIsCollapsed(!isCollapsed);
    onCollapse(!isCollapsed); // Notify parent about the collapse state
  };

  const notLegal = () => {
    return userAttributes && !userAttributes["roles"]?.includes("Legal")
  }

  return (
    <IonMenu className={isCollapsed ? "collapsed" : ""}>
      <IonHeader>
        <IonToolbar>
          <div className="menu-header">
            {!isCollapsed && <IonTitle>{labels.Menu}</IonTitle>}
            <IonIcon
              icon={!isCollapsed ? chevronBackOutline : menuOutline}
              onClick={toggleMenu}
              className={"toggle-button"}
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>

        <IonMenuToggle auto-hide="false">
          {notLegal() && (
            <IonItem button routerLink={"/home"} routerDirection="none">
              {!isCollapsed && <IonLabel>{labels.Home}</IonLabel>}
              <IonIcon icon={home} />
            </IonItem>
          )}


          {userAttributes &&
            (userAttributes["roles"]?.includes("Administrator") ||
              userAttributes["roles"]?.includes("Provider")) ? (
            <IonItem button routerLink={"/providers"} routerDirection="none">
              {!isCollapsed && <IonLabel>{labels.Providers}</IonLabel>}
              <IonIcon icon={business} />
            </IonItem>
          ) : (
            ""
          )}

          {notLegal() && (
            <IonItem button routerLink={"/users"} routerDirection="none">
              {!isCollapsed && <IonLabel>{labels.SystemUsers}</IonLabel>}
              <IonIcon icon={person} />
            </IonItem>
          )}


          {notLegal() && (
            <IonItem button routerLink={"/groups"} routerDirection="none">
              {!isCollapsed && <IonLabel>{labels.PatientsGroup}</IonLabel>}
              <IonIcon icon={people} />
            </IonItem>
          )}

          {notLegal() && (
            <IonItem button routerLink={"/threshold"} routerDirection="none">
              {!isCollapsed && <IonLabel>{labels.Threshold}</IonLabel>}
              <IonIcon icon={options} />
            </IonItem>
          )}



          {notLegal() && (
            <IonItem button routerLink={"/schedule"} routerDirection="none">
              {!isCollapsed && <IonLabel>{labels.ScheduleNotifications}</IonLabel>}
              <IonIcon icon={notifications} />
            </IonItem>
          )}

          {
            <IonItem button routerLink={"/addSurvey"} routerDirection="none">
              {!isCollapsed && <IonLabel>{labels.Survey}</IonLabel>}
              <IonIcon icon={analytics} />
            </IonItem>

          }

          {
            userAttributes && (userAttributes["roles"]?.includes("Administrator") || userAttributes["roles"]?.includes("Support") || userAttributes["roles"]?.includes("Legal"))
            && (
              <IonItem button routerLink={"/reviewSurvey"} routerDirection="none">
                {!isCollapsed && <IonLabel>{labels.ReviewSurvey}</IonLabel>}
                <IonIcon icon={analytics} />
              </IonItem>
            )
          }

          {notLegal() && (
            <IonItem button routerLink={"/patients"} routerDirection="none">
              {!isCollapsed && <IonLabel>{labels.displayLabel}</IonLabel>}
              <IonIcon icon={bed} />
            </IonItem>
          )}


          {notLegal() && (
            <IonItem button routerLink={"/contact-us"} routerDirection="none">
              {!isCollapsed && <IonLabel>{labels.ContactUs}</IonLabel>}
              <IonIcon icon={call} />
            </IonItem>
          )}

          {userAttributes &&
            userAttributes["roles"]?.includes("Administrator") ? (
            <IonItem
              button
              routerLink={"/billing-report"}
              routerDirection="none"
            >
              {!isCollapsed && <IonLabel>{labels.BillingReport}</IonLabel>}
              <IonIcon icon={fileTrayFullSharp} />
            </IonItem>
          ) : (
            ""
          )}

          {
            userAttributes && userAttributes["roles"]?.includes("Administrator") && (
              <IonItem button routerLink={"/hangfire"} routerDirection="none">
                {!isCollapsed && <IonLabel>{labels.HangfireDashboard}</IonLabel>}
                <IonIcon icon={pulse} />
              </IonItem>
            )
          }

          {
            userAttributes && (userAttributes["roles"]?.includes("Administrator") || userAttributes["roles"]?.includes("Support")) && (
              <IonItem button routerLink={"/unverified-users"} routerDirection="none">
                {!isCollapsed && <IonLabel>{'Unverified Users'}</IonLabel>}
                <IonIcon icon={people} />
              </IonItem>
            )
          }

          {notLegal() && (
            <IonItem button routerLink={"/fileManager"} routerDirection="none">
              {!isCollapsed && <IonLabel>{labels.FileManager}</IonLabel>}
              <IonIcon icon={folder} />
            </IonItem>
          )}

          <IonItem
            button
            onClick={() => logout()}
            routerDirection="none"
            routerLink={"/home"}
          >
            {!isCollapsed && <IonLabel>{labels.Signout}</IonLabel>}
            <IonIcon icon={exit} />
          </IonItem>
        </IonMenuToggle>

      </IonContent>
    </IonMenu>
  );
};
